import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import { Modal, ModalBody, ModalHeader } from "Components/ReactstrapSlim";

const defaultVideoId = "tESzcs9lCG8";

export interface HowItWorksModalProps {
   isOpen: boolean,
   videoUrl: string | undefined,
   toggle: () => void,
   autoplay?: boolean
}

function getYouTubeId(url: string) {
   const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
   return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
}

export const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, videoUrl, toggle, autoplay }) => {
   const [videoId, setVideoId] = useState(defaultVideoId);

   useEffect(() => {
      if (videoUrl) {
         let id = getYouTubeId(videoUrl);
         setVideoId(id);
      }
   }, [videoUrl]);

   return (<Modal isOpen={isOpen} toggle={toggle} className="onboarding-howitworks-video" centered>
      <ModalHeader toggle={toggle} className="h7">
         How it works
      </ModalHeader>
      <ModalBody className="ls-modal-body">
         <div>
            <YouTube videoId={videoId} opts={{ width: "100%", playerVars: { rel: 0, autoplay: autoplay ? 1 : 0 } }} />
         </div>
      </ModalBody>
   </Modal>)
}